import React, { useRef, useContext, useEffect, useState } from 'react';
// import { useLocation } from 'react-router-dom';

export const ResponsiveModeContext = React.createContext({
	index: 0,
	articles: [],
	article: null,
	setIsFontOpen: null,
	swiper: null,
	player: null,
	lang: 'en',
	onFontClick: null,
	onIsFavoriteClick: null,
	isFavorite: null,
	isOnline: null,
	isFontOpen: null,
	issue: null,
	onSearch: null,
	search: null,
	onTocItemClick: null,
	results: [],
	fontSize: 10,
	onFontSizeChange: null,
	theme: null,
	onArticleNextClick: null,
	onArticlePreviousClick: null,
	isLightboxMode: false,
	width: null,
	pages: [],
	onTransitionEnd: null,
	setSwiper: null,
	onLightboxMode: null,
	isTouchDevice: null,
	onLightboxTargetClick: null,
	// Nagivation Stack
	navigationStack: [],
	addToNavigationStack: () => {},
	popNavigationStack: () => {},
	clearNavigationStack: () => {},
});

export function useScrollToHash() {
	const { article, hash, setHash } = useContext(ResponsiveModeContext);
	useEffect(() => {
		console.log(`LOCATION: "${hash}"`);
		if (!hash.replace(/ /g, '').length) {
			return;
		}

		setTimeout(() => {
			const articleNode = document.getElementById(
				`article-${article.id}`
			);

			console.log(`THIS IS THE HASH: "${hash}"`);

			if (articleNode && !articleNode.querySelector(hash)) {
				console.log(
					`The hash "${location.hash}" do not exist in the article "${article.slug}"`
				);
				setHash(' ');
				return;
			}
			console.log(`I will scroll to the article`);
			scrollToElementId(hash.replace('#', ''));
		}, 500);
	}, [article, hash]);
}

export function useInternalLink() {
	const {
		articlesMap,
		issue,
		onTocItemClick,
		setHash,
		addToNavigationStack,
		article,
	} = useContext(ResponsiveModeContext);
	const contentRef = useRef(null);

	useEffect(() => {
		if (!contentRef || !issue || !articlesMap) {
			return;
		}

		processArticleNodes({
			contentRef,
			articlesMap,
			issue,
			onTocItemClick,
			setHash,
			addToNavigationStack,
		});
	}, [contentRef, issue, article]);

	return {
		contentRef,
	};
}

export function useArticleSearchResult(article) {
	const { search, lang } = useContext(ResponsiveModeContext);
	const [components, setComponents] = useState([]);
	useEffect(() => {}, []);
	useEffect(() => {
		if (!article) {
			setComponents([]);
			return;
		}
		setComponents(
			article.components.reduce(
				reduceSearchComponent({
					lang,
					search,
				}),
				[]
			)
		);
	}, [search, article]);
	return components;
}

function reduceSearchComponent({ lang, search }) {
	return (acc, component) => {
		const { text_lang } = component;
		const reg = new RegExp(search, 'gmi');
		// We check if the component has a text lang
		if (text_lang?.[lang] && reg.test(text_lang?.[lang])) {
			/*component.text_lang[lang] = text_lang[lang].replace(
				new RegExp(search, 'gmi'),
				(match, p1) => {
					return `<mark data-result-match id="result-mark-${id}-${p1}">${match}</mark>`;
				}
			);*/
			acc.push(component);
		}

		return acc;
	};
}

function processArticleNodes({
	contentRef,
	articlesMap,
	issue,
	onTocItemClick,
	setHash,
	addToNavigationStack,
}) {
	let nodes = Array.from(contentRef.current.querySelectorAll('article'));

	for (const node of nodes) {
		const article = articlesMap[node.getAttribute('data-article-id')];
		setTimeout(() => {
			processAnchorNodes({
				articlesMap,
				issue,
				article,
				onTocItemClick,
				setHash,
				addToNavigationStack,
			});
		}, 500);
	}
}

function getParentId(node) {
	if (node.id) {
		return node.id;
	}
	if (node.parentNode) {
		return getParentId(node.parentNode);
	}
}

function processAnchorNodes({
	articlesMap,
	issue,
	article,
	onTocItemClick,
	setHash,
	addToNavigationStack,
}) {
	const articleNode = document.getElementById(`article-${article.id}`);
	let nodes = Array.from(articleNode.querySelectorAll('a')).filter((node) => {
		if (node.getAttribute('data-article-id')) {
			return true;
		}
		let href = node.href
			.replace('https://', '')
			.replace('http://', '')
			.replace(node.host, '')
			.replace(/#[A-Z0-9a-z-]*/gim, '');
		return /\/article\/[0-9]/gim.test(href);
	});

	for (const node of nodes) {
		setInternalAnchorAttributes({ node, articlesMap, issue, article });
		const attributes = clone(getInternalAnchorAttributes(node));
		node.onclick = (e) => {
			e.preventDefault();
			const parentId = getParentId(node);

			if (!attributes) {
				return;
			}

			const {
				targetArticleId,
				targetElementId,
				originArticleId,
				originElementId,
				isSameArticle,
			} = attributes;

			if (isSameArticle) {
				navigateToElementInArticle(attributes);
			}

			const originArticle = clone(articlesMap[`${originArticleId}`]);
			const targetArticle = clone(articlesMap[targetArticleId]);
			addToNavigationStack({
				parentId,
				targetElementId,
				isSameArticle,
				article: originArticle,
				slug: originArticle.slug,
				element: originElementId,
				go: () => {
					onTocItemClick(originArticle);
					if (originElementId) {
						const interval = setInterval(() => {
							if (document.getElementById(originElementId)) {
								setTimeout(() => {
									setHash(`#${originElementId}`);
								}, 1000);
								clearInterval(interval);
							}
						}, 500);
					}
				},
			});
			onTocItemClick(targetArticle);
			if (targetElementId) {
				setTimeout(() => {
					setHash(`#${targetElementId}`);
				}, 1000);
			}
		};
	}
}

export function navigateToElementInArticle(attributes) {
	const { originId, targetElementId } = attributes;
	const idSelector = `article-${originId}`;
	const articleNode = document.getElementById(idSelector);

	if (articleNode && !articleNode.querySelector(`#${targetElementId}`)) {
		return;
	}
	history.replaceState(null, null, `#${targetElementId}`);
	scrollToElementId(targetElementId);
}

function getInternalAnchorAttributes(node) {
	if (!node.getAttribute('data-target-id')) {
		return null;
	}

	return {
		targetId: node.getAttribute('data-target-id'),
		targetArticleId: node.getAttribute('data-target-article-id'),
		targetElementId: node.getAttribute('data-target-element-id'),
		originId: node.getAttribute('data-origin-id'),
		originElementId: node.getAttribute('data-origin-element-id'),
		originArticleId: node.getAttribute('data-origin-article-id'),
		isSameArticle: JSON.parse(node.getAttribute('data-is-same-article-id')),
	};
}

function setInternalAnchorAttributes({ node, articlesMap, issue, article }) {
	if (node.getAttribute('data-target-id')) {
		return;
	}

	let href = node.href
		.replace('https://', '')
		.replace('http://', '')
		.replace(node.host, '')
		.replace(/#[A-Z0-9a-z-]*/gim, '');
	const [, , targetArticleId] = href.split('/');

	const targetArticle = clone(articlesMap[targetArticleId]);
	if (!targetArticle) {
		return;
	}

	let targetHref = [
		'/issues',
		issue.slug || issue.id,
		targetArticle.slug || targetArticle.id,
	].join('/');

	let elementId = null;

	if (node.href.split('#').length > 1) {
		elementId = node.href.split('#')[1];
		targetHref += `#${elementId}`;
	}

	const originElementId = getOriginElementId(node);

	node.setAttribute('href', targetHref);
	// Origin data
	node.setAttribute('data-origin-id', article.id);
	node.setAttribute('data-origin-article-id', article.ArticleID);
	if (originElementId) {
		node.setAttribute('data-origin-element-id', originElementId);
	}
	// Target data
	node.setAttribute('data-target-id', targetArticle.id);
	node.setAttribute('data-target-article-id', targetArticle.ArticleID);
	if (elementId) {
		node.setAttribute('data-target-element-id', elementId);
	}

	node.setAttribute(
		'data-is-same-article-id',
		targetArticleId === article.ArticleID
	);
}

function getOriginElementId(node) {
	const { id, parentNode } = node;
	if (id) {
		return id;
	}
	if (!parentNode) {
		return undefined;
	}
	return getOriginElementId(parentNode);
}

function clone(obj) {
	return obj ? JSON.parse(JSON.stringify(obj)) : obj;
}

export function scrollToElementId(id) {
	const el = document.getElementById(id);

	if (!el) {
		return;
	}

	el.scrollIntoView({
		behavior: 'smooth',
		block: 'start',
		inline: 'center',
	});
}

export function formatTime(seconds) {
	if (isNaN(seconds)) {
		seconds = 0;
	}
	const h = Math.floor(seconds / 3600);
	const m = Math.floor((seconds % 3600) / 60);
	const s = Math.round(seconds % 60);
	return [h, m > 9 ? m : h ? '0' + m : m || '0', s > 9 ? s : '0' + s]
		.filter(Boolean)
		.join(':');
}
